export const cssBundleHref = "/catalogo/build/css-bundle-6YW6GKXH.css";